<div class="dialog">
  <div class="dialog-background"></div>
  <div class="dialog-content">
    <h1 class="ds-title-3">{{ 'MIGRATION.overlay.title' | translate }}</h1>
    <p class="ds-running-1 ds-color-core-neutral-8">
      {{ 'MIGRATION.overlay.description' | translate }}
    </p>
    <p class="ds-heading-1">{{ 'MIGRATION.overlay.heading' | translate }}</p>
    <ul>
      <li class="ds-ui-1">{{ 'MIGRATION.overlay.bullet1' | translate }}</li>
      <li class="ds-ui-1">{{ 'MIGRATION.overlay.bullet2' | translate }}</li>
      <li class="ds-ui-1">{{ 'MIGRATION.overlay.bullet3' | translate }}</li>
      <li class="ds-ui-1">{{ 'MIGRATION.overlay.bullet4' | translate }}</li>
    </ul>
    <div class="ui-button-group">
      <app-ds-button (click)="onDismiss(true)" type="button">{{ 'MIGRATION.overlay.review' | translate }}</app-ds-button>
      <app-ds-button (click)="onDismiss(false)" type="button">{{ 'MIGRATION.overlay.continue' | translate }}</app-ds-button>
    </div>
  </div>
</div>
